// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginForm_wrapper__TzVPH","action":"LoginForm_action__Y8540","form":"LoginForm_form__67PwL","forgotPassword":"LoginForm_forgotPassword__1zUfX"};